/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  packageSelector.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/**
 * 判断aa数组是否全包含bb数组
 *
 */
export function isContained(aa, bb) {
    if (!(aa instanceof Array)
        || !(bb instanceof Array)
        || (aa.length < bb.length)
    ) {
        return false;
    }
    const aaStr = aa.toString();
    for (let i = 0; i < bb.length; i++) {
        if (aaStr.indexOf(bb[i]) < 0) {
            return false;
        }
    }
    return true;
}
